export default __webpack_public_path__ + "static/media/arquivo-do-card-respondido-icon.d4837cb6.svg";